angular.module('impactx.basketLink').controller('BasketLinkCtrl', ['AddToBasketService', 'ProductViewService', 'TranslationService', 'ThemeWorldService',
    '$context', '$scope', '$securityManager', 'dataGen', 'RFQSearchService', 'AppConfiguration',
    BasketLinkCtrl]);

function BasketLinkCtrl(AddToBasketService, ProductViewService, TranslationService, ThemeWorldService, $context, $scope, $securityManager, dataGen, RFQSearchService, AppConfiguration){
    var self = this;
    this.selectSupplier = AddToBasketService.selectSupplier;
    this.addToProductView = ProductViewService.addProductsToProductView;
    this.addToRFQS = RFQSearchService.addToRFQS;
    this.addToRFQH = RFQSearchService.addToRFQH;
    this.addToThemeWorld = ThemeWorldService.addProductsToThemeWorld;
    this.removeFromThemeWorld = function(product) {
        var proIds = [];
        product.basketLink.canAddToThemeWorld = true;
        product.basketLink.canRemoveFromThemeWorld = false;
        proIds.push(product.id);
        ThemeWorldService.removeProductsFromThemeWorld($context.hasActiveThemeWorld.id, proIds);
    };
    this.removeFromProductView = function(product) {
        var proIds = [];
        product.basketLink.canAddToProductView = true;
        product.basketLink.canRemoveFromProductView = false;
        proIds.push(product.id);
        ProductViewService.removeProductsFromProductView($context.hasActiveThemeWorld.id, proIds);
    };
    this.addToProductViewLabel = TranslationService.get('add');
    this.addToThemeWorldLabel = TranslationService.get('add');
    this.removeFromThemeWorldLabel = TranslationService.get('remove');
    this.addToRFQSLabel = TranslationService.get('addToRFQS');
    this.addToRFQHLabel = TranslationService.get('addToRFQH');
    this.removeFromProductViewLabel = TranslationService.get('remove');
    this.coAmountFill = TranslationService.get("coAmountFill");
    this.minAmount = TranslationService.get("minAmount");
    this.stepSize = TranslationService.get("stepSize");
    this.perLabel = TranslationService.get("per");
    this.rangeLabel = TranslationService.get("range");
    this.andLabel = TranslationService.get("and");
    this.orderStopNotificationLabel = TranslationService.get("orderStopNotification");
    this.soldOutLabel = TranslationService.get("soldOut");
    this.inStock = TranslationService.get("inStock");
    this.addToBasketTimeout = AppConfiguration.get("addToBasketTimeout");

    $scope.$watch(function() {
        return $scope.basketLink
    }, function() {
        self.ostNotificationSet = impactX.isDefined($scope, 'basketLink.ostNotificationSet');
        self.hasOrderStop = impactX.isDefined($scope, 'basketLink.hasOrderStop');
        self.canSetOstNotification = impactX.isDefined($scope, 'basketLink.canSetOstNotification');
        self.showChangeOstNotification = self.hasOrderStop && $securityManager.isProcessAllowed("OrderStopNotification")
            && (self.canSetOstNotification !== false || self.ostNotificationSet);
    });

    this.addToBasket = function (product, amount, actionLabel, askSupplier, $event, vCatId)
    {
        if(self.addToBasketTimeout > 0)
        {
            const button = $event.target;
            button.disabled = true;
            setTimeout(() => { button.disabled = false; }, self.addToBasketTimeout);
        }
        AddToBasketService.addToBasket(product, amount, actionLabel, askSupplier, $event, vCatId);
    }

    this.changeOstNotification = function () {
        dataGen.postAsForm({}, {proId: $scope.product.id, setNotification: self.ostNotificationSet}, "/catalog/orderstop/notification/change").then(angular.noop(),
            function () {
                $route.reload();
            });
    }
}